/**
 * CONNOX GMBH CONFIDENTIAL
 * ________________________
 *
 * Copyright (c) 2005 - 2018 Connox GmbH, All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property
 * of Connox GmbH and its suppliers, if any. The intellectual and
 * technical concepts contained herein are proprietary to Connox GmbH and
 * its suppliers and may be covered by German Laws and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is
 * strictly forbidden unless prior written permission is obtained from
 * Connox GmbH.
 */
import {ICartMessage} from "../CartMessage";

/**
 * An Error wrapper for CartMessage
 */
export class CartError extends Error implements ICartMessage {
  public readonly code: string;
  public readonly field: string;
  public readonly type: "error" | "info" | "warning";

  /**
   * Creates a new instance from a CartMessage
   * @param {ICartMessage} message
   */
  constructor(message: ICartMessage) {
    super(message.message);
    this.code = message.code;
    this.field = message.field;
    this.type = message.type;
  }
}
